module.exports = __webpack_public_path__ + "img/satellite.f1c49a36.png";